import React from "react";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { Box, Typography, TextField } from "@mui/material";
import './SourceForm.css';
export const SourceForm = (props) => {
  const { srcName, setSrcName, srcApiKeyName, setSrcApiKeyName, srcApiKey, setSrcApiKey, setSourceUrl, sourceUrl } = props;

  return (
    <Box className="Box1">
      <FormControl className="TextField1" variant="standard" sx={{ display: "flex", flexDirection: "column", gap: "0px" }}>
        <TextField id="outlined-basic" label="Source Name" variant="outlined" value={srcName.value} InputLabelProps={{ shrink: srcName ? true : false }} onChange={e => setSrcName({ ...srcName, value: e.target.value })} />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>{srcName.error}</FormHelperText>
      </FormControl>
      <FormControl className="TextField1" variant="standard" fullWidth sx={{ display: "flex", flexDirection: "column", }}>
        <TextField id="outlined-basic" label="Api Key Name" variant="outlined" value={srcApiKeyName.value} InputLabelProps={{ shrink: srcApiKeyName ? true : false }} onChange={e => setSrcApiKeyName({ ...srcApiKeyName, value: e.target.value })} />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>{srcApiKeyName.error}</FormHelperText>
      </FormControl>
      <FormControl className="TextField1" variant="standard" fullWidth sx={{ display: "flex", flexDirection: "column", }}>
        <TextField id="outlined-basic" label="Api Key" variant="outlined" value={srcApiKey.value} InputLabelProps={{ shrink: srcApiKey ? true : false }} onChange={e => setSrcApiKey({ ...srcApiKey, value: e.target.value })} />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>{srcApiKey.error}</FormHelperText>
      </FormControl>

    </Box>
  );
};